<div class="card">
  <div class="row">
    <div class="col-12 col-md-6">
      <category-tree
        [categoryTreeLabel]="'product.tab.categories.categories'"
        [type]="categoryTreeTypeEnum.checkboxProductCategories"
        [selectedCategories]="filteredCategories"
        (selectedCategoriesChange)="onFilterCategoriesChange($event)"
      >
      </category-tree>
    </div>

    <div class="col-12 col-md-6">
      <div class="display-flex flex-row justify-content-between mb-1">
        <div class="font-weight-bold">{{ 'menu.products' | translate }}</div>
        <div class="pagination-detail" [innerHTML]="paginationDetail"></div>
      </div>
      <div class="col">
        <form-row-input
          [label]="'product.template.search' | translate"
          [model]="searchPhrase"
          (modelChange)="searchPhrase = $event; templateSearchChange()"
          [appendBtnIcon]="'far-search'"
          [appendBtnTitle]="'filter' | translate"
          [appendBtnClasses]="['btn-search']"
          (onAppendBtnEvent)="templateSearchChange()"
          (onKeyPress)="templateSearchChange()"
        ></form-row-input>
      </div>
      <loading-spinner [isLoading]="isLoading" [classesString]="'top-25'"></loading-spinner>
      <div class="row" *ngIf="!isLoading">
        <div class="col">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th class="fixed-column-width" scope="col">&nbsp;</th>
                  <th scope="col">
                    {{ 'product.template.name' | translate }}
                  </th>
                  <th scope="col" class="cursor-pointer text-nowrap d-none d-xl-table-cell">
                    {{ 'product.producer.name' | translate }}
                  </th>
                  <th scope="col" class="cursor-pointer text-nowrap d-none d-xl-table-cell">
                    {{ 'product.code3' | translate }}
                  </th>
                  <th class="fixed-column-width" scope="col">&nbsp;</th>
                </tr>
              </thead>

              <tbody *ngIf="(filteredCategories?.length > 0 || searchPhrase?.length > 0) && templates?.length === 0">
                <tr>
                  <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                    <div class="empty-list">
                      <i class="far fa-sad-tear"></i>
                      <div>
                        {{ 'no.record.found' | translate }}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>

              <tbody *ngIf="filteredCategories?.length < 1 && searchPhrase?.length < 1 && templates?.length === 0">
                <tr>
                  <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                    <div class="empty-list">
                      {{ 'product-template-selection.search' | translate }}
                    </div>
                  </td>
                </tr>
              </tbody>

              <tbody *ngIf="templates?.length > 0" class="images" [photoGalleryGroup]="{ index: 1 }">
                <tr *ngFor="let template of templates">
                  <td>
                    <div
                      [photoGallery]="getThumbUrl(template.images[0], 'w2048wp')"
                      [photoGalleryCaption]="
                        template.name +
                        '<br>' +
                        (template.code ? ('product-template-selection.code' | translate) + template.code : '') +
                        '<br>' +
                        (template.ean ? ('product-template-selection.ean' | translate) + template.ean : '')
                      "
                    >
                      <div class="images-item">
                        <img class="images-item-image" [src]="getThumbUrl(template.images[0])" [alt]="template.name" />
                      </div>
                    </div>
                  </td>
                  <td class="pl-1">
                    {{ template.name ? template.name : '' }}
                  </td>
                  <td>
                    {{ template.manufacturer }}
                  </td>
                  <td>
                    {{ template.manuCode }}
                  </td>
                  <td class="pr-1 text-right fixed-column-width">
                    <btn
                      [icon]="'far fa-chevron-right'"
                      [label]="'select'"
                      [classes]="['btn-second', 'btn-sm']"
                      (onEvent)="selectTemplate(template)"
                      data-cy="select-template"
                    ></btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
